class FeaturedReviewsCarousel extends HTMLElement {
  constructor() {
    super()

    this.sectionId = this.dataset.sectionId
    this.mobilePerPage = this.dataset.mobilePerPage || 1.25
    this.tabletPerPage = this.dataset.tabletPerPage || 2.2
    this.sdesktopPerPage = this.dataset.sdesktopPerPage || 2
    this.desktopPerPage = this.dataset.desktopPerPage || 2
    this.ldesktopPerPage = this.dataset.ldesktopPerPage || 2

    this._doInit = this._doInit.bind(this)
  }

  connectedCallback() {
    const option = {
      init: false,
      spaceBetween: 15,
      slidesPerView: this.mobilePerPage,
      preventClicks: false,
      preventClicksPropagation: false,
      slidesOffsetAfter: 20,
      slidesOffsetBefore: 20,
      slidesPerGroup: 1,
      a11y: {
        enabled: false,
      },
      navigation: {
        nextEl: '.featured_reviews--icon-next',
        prevEl: '.featured_reviews--icon-previous',
      },
      pagination: {
        el: '.swiper-pagination',
        type: 'progressbar'
      },
      breakpoints: {
        768: {
          slidesPerView: this.tabletPerPage,
          slidesOffsetAfter: 45,
          slidesOffsetBefore: 45,
        },
        1024: {
          slidesPerView: this.sdesktopPerPage,
          slidesOffsetAfter: 0,
          slidesOffsetBefore: 0,
        },
        1200: {
          slidesPerView: this.desktopPerPage,
          slidesOffsetAfter: 0,
          slidesOffsetBefore: 0,
        },
        1600: {
          slidesPerView: this.ldesktopPerPage,
          slidesOffsetAfter: 0,
          slidesOffsetBefore: 0,
        },
      }
    }

    this.$swiper = new Swiper('.js-featured-reviews-carousel', option)
    this.$swiper.on('init', this._doInit)
    this.$swiper.on('resize', (swiper) => {
      this._doInit()
    })
    this.$swiper.init()
  }

  _doInit() {
    const cardWrapper = this.$swiper.el.querySelector(
      '.featured_reviews--card',
    )
    if (cardWrapper) {
      const h = cardWrapper.getBoundingClientRect().height
      this.style.setProperty('--block-height', `${h}px`)
    }
  }
}

customElements.define('featured-reviews-carousel', FeaturedReviewsCarousel)
